// extracted by mini-css-extract-plugin
export default {"header":"Header_header__uyV1K","logo":"Header_logo__6vptJ"};